module.exports = __webpack_public_path__ + "img/bhl4.a36df930.webp";